import { localStorageController } from '@/lib/localStorageController';

export const localeStorage = {
  getItem: () => localStorageController.get('locale'),
  setItem: (value: string): void => localStorageController.set('locale', value),
};
